/* eslint-disable max-lines-per-function */
import ArtworkMultiDimensions from "./ArtworkMultiDimensions.vue";
import StepWrapper from "../common/StepWrapper.vue";
import PreCut from "../PreCut.vue";
import UploadBox from "../UploadBox.vue";

export default function MultiSizeStep({
  artwork = null,
  index = 0,
  disabled = false,
  readonly = false,
  withPreCut = false,
  showMultiUploadBox = false,
  showFileDialog = null,
  showFreeTransfersBadge = false,
  onShowFileDialog,
  ...restProps
}) {
  function handleShowFileDialog(data) {
    onShowFileDialog?.(data);
  }

  return (
    <StepWrapper
      {...restProps}
      stepNumber={2}
      headerText="Set Design Size"
      data-testid="step-wrapper"
    >
      <ArtworkMultiDimensions
        artwork={artwork}
        index={index}
        disabled={disabled}
        readonly={readonly}
        showFreeTransfersBadge={showFreeTransfersBadge}
        data-testid="artwork-multi-dimensions"
      />
      {withPreCut ? <PreCut data-testid="pre-cut" /> : null}
      {showMultiUploadBox ? (
        <UploadBox onUpload={handleShowFileDialog} data-testid="upload-box" />
      ) : null}
    </StepWrapper>
  );
}
